export default {
    metadata: {
        extractslocationsLabel: "Extrait pertinent",
        extractslocationsPluralLabel: "Extraits pertinents",
        geoLabel: "Lieu",
        geoPluralLabel: "Lieux",
        personLabel: "Personne",
        personPluralLabel: "Personnes",
        companyLabel: "Société",
        companyPluralLabel: "Sociétés",
        treepathLabel: "Source",
        treepathPluralLabel: "Sources",
        matchlocationsLabel: "Terme recherché",
        matchlocationsPluralLabel: "Termes recherchés",
        titleLabel: "Titre",
        titlePluralLabel: "Titres",
        authorsLabel: "Auteur",
        authorsPluralLabel: "Auteurs",
        filenameLabel: "Nom de fichier",
        filenamePluralLabel: "Noms de fichiers",
        modifiedLabel: "Date",
        modifiedPluralLabel: "Dates",
        sizeLabel: "Taille",
        sizePluralLabel: "Tailles",
        docformatLabel: "Format",
        docformatPluralLabel: "Formats",
        documentlanguagesLabel: "Langue",
        documentlanguagesPluralLabel: "Langues",
        geo_label: "Lieu",
        geo_plural_label: "Lieux",
        person_label: "Personne",
        person_plural_label: "Personnes",
        company_label: "Société",
        company_plural_label: "Sociétés",
        treepath_label: "Source",
        treepath_plural_label: "Sources",
        title_label: "Titre",
        title_plural_label: "Titres",
        authors_label: "Auteur",
        authors_plural_label: "Auteurs",
        filename_label: "Nom de fichier",
        filename_plural_label: "Noms de fichiers",
        modified_label: "Date",
        modified_plural_label: "Dates",
        size_label: "Taille",
        size_plural_label: "Tailles",
        docformat_label: "Format",
        docformat_plural_label: "Formats",
        documentlanguages_label: "Langue",
        documentlanguages_plural_label: "Langues",
        accessLists: {
            authorizedListTitleText: "Accès autorisés",
            authorizedListHeader: "Liste d'accès autorisés {value, number}",
            deniedListTitleText: "Accès refusés",
            deniedListHeader: "Liste d'accès refusés {value, number}"
        },
        item: {
            label: "{label}:",
            separator: " ",
            treeSeparator: " ; ",
            treeNodeSeparator: "/",
            listSeparator: ", ",
            empty_boolean: 'false',
            empty_number: '0'
        }
    },
};
